var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-text-field',_vm._g(_vm._b({attrs:{"placeholder":_vm.placeholder,"label":_vm.with_label ? _vm.placeholder : undefined,"autocomplete":"new-password"}},'w-text-field',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }